// extracted by mini-css-extract-plugin
var _1 = "ln8NT";
export { _1 as "base" }
